import { take, put, fork, all } from 'redux-saga/effects';
import { MassageTherapyActionTypes } from './type';

function* select_shop() {
  while (true) {
    const { data } = yield take(MassageTherapyActionTypes.SELECT_SHOP);
    yield put({ type: MassageTherapyActionTypes.SELECT_SHOP, data });
  }
}
function* select_product() {
  while (true) {
    const { data, callback } = yield take(MassageTherapyActionTypes.SELECT_PRODUCT);
    yield put({ type: MassageTherapyActionTypes.SELECT_PRODUCT, data });
    typeof callback === 'function' && callback();
  }
}

export default function* root() {
  yield all([fork(select_shop), fork(select_product)]);
}
